module.exports = __webpack_public_path__ + "img/ikona-oferta.4b02eff9.svg";